import HelpPopover from '../help/HelpPopover'

/**
 * The Topics card in the Evidence lens's left column (figure S2).
 *
 * These are the topics the AI read OUT of this document — they drive prior-art
 * and journal search and blind matching, and they are never shared as text.
 * They come from the document record and nowhere else: a document the pipeline
 * has not read yet has no topics, and this card says so rather than showing the
 * invention's topics as if they were this document's.
 */
export interface DocumentTopicsCardProps {
  topics?: string[]
}

export default function DocumentTopicsCard({ topics }: DocumentTopicsCardProps) {
  return (
    <section data-part="DocumentTopicsCard" className="light-card p-4">
      <h3 className="flex items-center gap-1.5 text-[13px] font-bold text-iflow-900">
        <span aria-hidden>🏷</span> <span>Topics</span>
        <HelpPopover
          topic="concept-document-topics"
          title="Topics"
          body="Topics the AI read from this document. They drive prior-art and journal search and blind matching — never shared as text."
          size={14}
        />
      </h3>
      <p className="mb-2 mt-0.5 text-[11.5px] text-gray-500">Read from the document by the AI.</p>
      {topics && topics.length > 0 ? (
        <div className="flex flex-wrap gap-1.5">
          {topics.map((topic) => (
            <span key={topic} className="rounded-full border border-sky-200 bg-sky-50 px-2.5 py-0.5 text-[11px] text-iflow-800">
              {topic}
            </span>
          ))}
        </div>
      ) : (
        <p className="text-[11.5px] text-gray-500">
          No topics have been read from this document yet. They appear once it has been analysed.
        </p>
      )}
    </section>
  )
}
